<template>
  <div :class="isH5?'head-top-wrpah':'head-top-wrpa'">
    <div
      v-if="!isH5"
      class="head-top"
    >
      <header class="headroom">
        <div class="headroom">
          <a
            href="#"
            class="logo fl"
          >
            <img
              src="@/image/logo.png"
              alt="witfort"
              width="84"
              height="47"
            />
          </a>
          <div class="fr">
            <nav
              class="nav flex align-items_center"
              :class="nalClass"
            >
              <ul
                class="clearfix"
                style="margin-right:-20px;"
              >
                <li
                  @click="goNav(item.path)"
                  v-for="(item,index) in navList"
                  :key="index"
                  :class="[{'sel-LI':index==selindex},{'nosel':index!=selindex}]"
                >{{item.name}}</li>
              </ul>
              <div class="flex align-items_center nav-call">
                <img
                  v-if="nalClass=='nav1'"
                  style="display:block;"
                  src="@/image/index/jp_phone.png"
                  width="29"
                  height="29"
                >
                <img
                  v-if="nalClass=='nav2'"
                  style="display:block;"
                  src="@/image/index/icon_call.png"
                  width="29"
                  height="29"
                >
                <div class="c_white fs24">0755-369915</div>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </div>
    <div
      v-else-if="isH5"
      class="head-top-h flex "
      :style="bgcop"
    >
      <img
        class="m-head-logo"
        src="@/image/logo.png"
        alt=""
      >
      <img
        class="m-head-nav"
        src="@/image/mobile/icon_head.png"
        alt=""
        @click="show2 = !show2"
      >
      <transition name="el-zoom-in-top">
        <div
          v-show="show2"
          class="m-head-nav-ul"
          :style="bgcop"
        >
          <div
            @click="goNav(item.path)"
            v-for="(item,index) in navList"
            :key="index"
          >{{item.name}}</div>
        </div>
      </transition>
    </div>
  </div>

</template>

<script>
export default {
  name: "headtop",
  props: {
    selindex: {
      type: Number,
      default: 0,
    },
    nalClass: {
      type: String,
      default: 'nav1'
    },
    isH5: {
      type: Boolean,
      defalut: false
    }
  },
  data () {
    return {
      show2: false,
      navList: [
        { name: "家品首页", path: "index" },
        { name: "关于家品", path: "about" },
        { name: "公司产品", path: "product" },
        { name: "联系家品", path: "contact" }
      ],
      eyop: 0
    };
  },
  computed: {
    bgcop () {
      return `background: rgba(255, 255, 255, ${0.5 + this.eyop})`
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    goNav (name) {
      if (!name) return;
      this.$router.push({ name });
    },
    handleScroll () {
      let _this = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.eyop = scrollTop >= 0 ? (scrollTop > 100 ? 0.5 : (scrollTop / 100) * 0.5) : 0
    }
  },
};
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>



// WEBPACK FOOTER //
// src/components/headtop/headtop.vue